<template>
  <div>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <BaseInputValidation
              id="login"
              name="Login *"
              v-model="profile.email"
              disabled
              :loading="loading"
            ></BaseInputValidation>
          </v-col>
          <v-col cols="3">
            <BaseSelectValidation
              outlined
              :disabled="view"
              :items="situacoes"
              item-value="value"
              item-text="name"
              rules="required"
              placeholder="Selecione"
              label="Selecione *"
              name="Status *"
              v-model="form.status"
              :loading="loading"
            ></BaseSelectValidation>
          </v-col>
          <v-col cols="3">
            <BaseDatepickerValidation
              :disabled="view"
              v-model="form.start_validity"
              idDatePicker=""
              rules="required"
              label="Validade do Acesso(de) *"
              name="Validade do Acesso inicial *"
              :min="minDateInit()"
              :max="form.end_validity"
              :clearable="true"
              :loading="loading"
            ></BaseDatepickerValidation>
          </v-col>
          <v-col cols="3">
            <BaseDatepickerValidation
              :disabled="view"
              rules="required"
              v-model="form.end_validity"
              idDatePicker=""
              label="Validade do Acesso(até) *"
              name="Validade do Acesso Final *"
              :min="minDateEnd()"
              :clearable="true"
              :loading="loading"
            ></BaseDatepickerValidation>
          </v-col>
          <template v-if="!view">
            <v-col cols="3">
              <BaseSelectValidation
                v-model="permission.feature_id"
                outlined
                item-value="id"
                item-text="title"
                placeholder="Funcionalidade"
                label="Funcionalidade"
                name="Funcionalidade"
                :disabled="view"
                :items="features"
                :loading="loading"
              ></BaseSelectValidation>
            </v-col>
            <v-col cols="3">
              <BaseSelectValidation
                v-model="permission.action_id"
                outlined
                item-value="id"
                item-text="title"
                placeholder="Ação"
                label="Ação"
                name="Ação"
                :disabled="view"
                :items="actions"
                :loading="loading"
              ></BaseSelectValidation>
            </v-col>
            <v-col cols="3">
              <v-btn class="btn-novo" @click="addPermission">
                <span class="icon-plus-1"></span>
                <span>Adicionar</span>
              </v-btn>
            </v-col>
          </template>
        </v-row>
        <v-row>
          <v-col cols="6">
            <BaseDataTable
              disable-sort
              :headers="headers"
              :items="form.permissions"
              @onDelete="deleteItem"
            >
              <template v-slot:[`item.nm_feature`]="{ item }">
                {{ getFeatureTitleById(item.feature_id) }}
              </template>
              <template v-slot:[`item.nm_action`]="{ item }">
                {{ getActionTitleById(item.action_id) }}
              </template>
            </BaseDataTable>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import BaseDatepickerValidation from "../../../../components/UI/BaseDatePickerValidation.vue";
import BaseInputValidation from "../../../../components/UI/BaseInputValidation";
import BaseSelectValidation from "../../../../components/UI/BaseSelectValidation";
import BaseDataTable from "../../../../components/UI/BaseDataTable";
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  components: {
    BaseInputValidation,
    BaseSelectValidation,
    BaseDatepickerValidation,
    BaseDataTable
  },
  props: {
    profile: {
      type: Object
    },
    view: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    features: {
      type: Array,
      default: () => []
    },
    actions: {
      type: Array,
      default: () => []
    }
  },
  created() {
    this.form = Object.assign(this.form, this.profile);
  },
  watch: {
    form: {
      handler(newVal) {
        this.$emit("setFields", {
          data: newVal
        });
      },
      deep: true
    },
    profile() {
      this.form = Object.assign(this.form, this.profile);
    }
  },
  data() {
    return {
      situacoes: [
        { name: "Ativo", value: true },
        { name: "Inativo", value: false }
      ],
      form: {
        status: "",
        start_validity: "",
        end_validity: "",
        permissions: []
      },
      permission: {},
      headers: [
        {
          value: "actions",
          actions: [
            {
              type: "button",
              click: "onDelete",
              icon: "icon-lixeira",
              hide: () => !this.view,
              options: { fab: true, icon: true, small: true }
            }
          ]
        },
        { text: "Funcionalidade", value: "nm_feature" },
        { text: "Ação", value: "nm_action" }
      ]
    };
  },
  methods: {
    minDateInit() {
      return new Date().toISOString().slice(0, 10);
    },
    minDateEnd() {
      if (this.form.start_validity) {
        return this.form.start_validity;
      } else {
        return new Date().toISOString().slice(0, 10);
      }
    },
    getFeatureTitleById(id) {
      return this.features.find(item => item.id == id)?.title;
    },
    getActionTitleById(id) {
      return this.actions.find(item => item.id == id)?.title;
    },
    addPermission() {
      if (
        this.permission.feature_id != undefined &&
        this.permission.action_id != undefined
      )
        if (
          !this.form.permissions.some(
            item =>
              item.feature_id == this.permission.feature_id &&
              item.action_id == this.permission.action_id
          )
        ) {
          this.form.permissions.push(this.permission);
          this.permission = {};
        }
    },
    deleteItem(item) {
      this.form.permissions.splice(this.form.permissions.indexOf(item), 1);
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .btn-novo {
  margin-top: 10px;
  background: #ebe6e6 !important;
  border: 1px solid #ffffff;
  box-sizing: border-box;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.25);
  border-radius: 46px !important;
  padding: 0 20px 0 20px !important;
  span {
    font-weight: 300;
    font-size: 15px;
    line-height: 29px;
    text-align: center;

    color: #444444;
  }
}
</style>
